<template>
  <div
    class="flex w-[calc(var(--u)*40)] flex-col items-stretch justify-center overflow-hidden rounded-lg bg-white text-center text-black shadow-lg dark:bg-gray-700 dark:text-white"
    :style="{ '--u': `${scale}px` }"
  >
    <div
      class="bg-red-400 py-[calc(var(--u)*1.5)] text-[length:calc(var(--u)*9)] font-bold leading-[calc(var(--u)*8)] dark:bg-red-900"
    >
      <time :datetime="isoDate">{{ weekday }}</time>
    </div>

    <div class="py-[calc(var(--u)*1.5)]">
      <time
        :datetime="isoDate"
        class="block text-[length:calc(var(--u)*12.8)] font-semibold leading-[calc(var(--u)*11.2)]"
        >{{ day }}</time
      >
      <time
        :datetime="isoDate"
        class="mt-[calc(var(--u)*2)] block text-[length:calc(var(--u)*8)] font-semibold uppercase leading-[calc(var(--u)*8)]"
        >{{ month }}</time
      >
    </div>

    <div
      class="bg-red-400 py-[calc(var(--u)*1.5)] text-[length:calc(var(--u)*7)] font-bold leading-[calc(var(--u)*7)] dark:bg-red-900"
    >
      <time :datetime="isoDate">{{ year }}</time>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { locale } = useI18n({ useScope: "global" });

const localeConverted = computed<string>(() => locale.value.replace("_", "-"));

const props = withDefaults(
  defineProps<{
    date: string;
    small?: boolean;
  }>(),
  { small: false }
);

const dateObj = computed<Date>(() => new Date(props.date));
const isoDate = computed<string>(() => dateObj.value.toISOString());

const scale = computed<number>(() => (props.small ? 1.2 : 2));

const format = (options: Intl.DateTimeFormatOptions): string =>
  dateObj.value.toLocaleString(localeConverted.value, options);

const month = computed<string>(() => format({ month: "short" }));
const day = computed<string>(() => format({ day: "numeric" }));
const weekday = computed<string>(() => format({ weekday: "short" }));
const year = computed<string>(() => format({ year: "numeric" }));
</script>
